function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.07,
  d: "M35.9169 10.9281H8.02681C6.54515 10.9281 5.41211 12.112 5.41211 13.6601V30.0523C5.41211 31.6004 6.6323 32.7843 8.02681 32.7843H35.9169C37.3986 32.7843 38.5316 31.6004 38.5316 30.0523V13.6601C38.5316 12.112 37.3115 10.9281 35.9169 10.9281Z",
  fill: "#373D49"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M35.9174 11.8388C36.8762 11.8388 37.6606 12.6584 37.6606 13.6601V30.0523C37.6606 31.054 36.8762 31.8736 35.9174 31.8736H8.02731C7.06859 31.8736 6.28418 31.054 6.28418 30.0523V13.6601C6.28418 12.6584 7.06859 11.8388 8.02731 11.8388H35.9174Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 18.4857,
  cy: 21.8562,
  rx: 6.10097,
  ry: 6.37473,
  fill: "#EB001B"
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 25.4584,
  cy: 21.8562,
  rx: 6.10097,
  ry: 6.37473,
  fill: "#F79E1B"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M24.5868 21.8562C24.5868 19.6706 23.5409 17.7582 21.9721 16.6653C20.4033 17.8492 19.3574 19.7616 19.3574 21.8562C19.3574 23.9507 20.4033 25.9542 21.9721 27.047C23.5409 25.9542 24.5868 24.0418 24.5868 21.8562Z",
  fill: "#FF5F00"
});

function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 43 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.94fe44fe.svg";
export { ForwardRef as ReactComponent };